/* ============================================================
   KCAL HYDRA+ SHOPIFY THEME — theme.js
   Handles: mobile menu, flavour carousel, FAQ accordion,
            product qty, thumbnail gallery, scroll animations
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE MENU ── */
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      const open = mobileNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
  }

  /* ── FLAVOUR CAROUSEL ── */
  const tabs = document.querySelectorAll('.flavour-tab');
  const cards = document.querySelectorAll('.flavour-card');
  let current = 0;

  function showFlavour(idx) {
    tabs.forEach(t => t.classList.remove('active'));
    cards.forEach(c => c.classList.remove('active'));
    if (tabs[idx]) tabs[idx].classList.add('active');
    if (cards[idx]) cards[idx].classList.add('active');
    current = idx;
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { showFlavour(i); });
  });

  const prevBtn = document.getElementById('carousel-prev');
  const nextBtn = document.getElementById('carousel-next');
  if (prevBtn) prevBtn.addEventListener('click', function () {
    showFlavour((current - 1 + tabs.length) % tabs.length);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    showFlavour((current + 1) % tabs.length);
  });

  var flavourCarousel = document.querySelector('.flavour-carousel');
  if (flavourCarousel && tabs.length > 1) {
    var flavourSwipeStartX = 0;
    var flavourSwipeStartY = 0;
    flavourCarousel.addEventListener('touchstart', function (e) {
      flavourSwipeStartX = e.changedTouches[0].clientX;
      flavourSwipeStartY = e.changedTouches[0].clientY;
    }, { passive: true });
    flavourCarousel.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - flavourSwipeStartX;
      var dy = e.changedTouches[0].clientY - flavourSwipeStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        showFlavour(dx < 0
          ? (current + 1) % tabs.length
          : (current - 1 + tabs.length) % tabs.length);
      }
    }, { passive: true });
  }

  /* ── FAQ ACCORDION ── */
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const answer = btn.nextElementSibling;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      // Close all
      document.querySelectorAll('.faq-question').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
      });
      // Toggle clicked
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        if (answer) answer.classList.add('open');
      }
    });
  });

  /* ── PRODUCT QUANTITY ── */
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus = document.getElementById('qty-plus');
  const qtyInput = document.getElementById('qty-input');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      const v = parseInt(qtyInput.value, 10);
      if (v > 1) {
        qtyInput.value = v - 1;
        qtyInput.dispatchEvent(new Event('change'));
      }
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      qtyInput.dispatchEvent(new Event('change'));
    });
  }

  /* ── PRODUCT THUMBNAIL GALLERY ── */
  var GALLERY_DURATION = 350;

  function slideGalleryImage(newSrc, dir) {
    var container  = document.querySelector('.product-main-img');
    var currentImg = document.getElementById('main-product-img');
    if (!container || !currentImg) return;
    if (container.dataset.animating) return;
    container.dataset.animating = '1';

    var enterFrom = dir > 0 ? '100%' : '-100%';
    var exitTo    = dir > 0 ? '-100%' : '100%';

    var nextImg = document.createElement('img');
    nextImg.src = newSrc;
    nextImg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;transform:translateX(' + enterFrom + ')';

    var transition = 'transform ' + GALLERY_DURATION + 'ms ease-in-out';
    currentImg.style.transition = transition;
    currentImg.style.willChange = 'transform';
    nextImg.style.transition    = transition;
    nextImg.style.willChange    = 'transform';

    container.appendChild(nextImg);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        currentImg.style.transform = 'translateX(' + exitTo + ')';
        nextImg.style.transform    = 'translateX(0)';
      });
    });

    setTimeout(function () {
      nextImg.id         = 'main-product-img';
      nextImg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain';
      currentImg.remove();
      delete container.dataset.animating;
    }, GALLERY_DURATION + 20);
  }

  function navigateGallery(dir) {
    var thumbs = Array.from(document.querySelectorAll('.product-thumb'));
    if (!thumbs.length) return;
    var activeIdx = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
    var nextIdx   = (activeIdx + dir + thumbs.length) % thumbs.length;
    var target    = thumbs[nextIdx];
    slideGalleryImage(target.dataset.full, dir);
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    target.classList.add('active');
  }

  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var thumbs     = Array.from(document.querySelectorAll('.product-thumb'));
      var currentIdx = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
      var clickedIdx = thumbs.indexOf(thumb);
      if (currentIdx === clickedIdx) return;
      slideGalleryImage(thumb.dataset.full, clickedIdx > currentIdx ? 1 : -1);
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ── PRODUCT GALLERY ARROWS ── */
  var galleryPrev = document.getElementById('gallery-prev');
  var galleryNext = document.getElementById('gallery-next');
  if (galleryPrev && galleryNext) {
    galleryPrev.addEventListener('click', function () { navigateGallery(-1); });
    galleryNext.addEventListener('click', function () { navigateGallery(1); });
  }

  /* ── PRODUCT GALLERY SWIPE ── */
  var productMainImg = document.querySelector('.product-main-img');
  if (productMainImg) {
    var swipeStartX = 0;
    var swipeStartY = 0;
    productMainImg.addEventListener('touchstart', function (e) {
      swipeStartX = e.changedTouches[0].clientX;
      swipeStartY = e.changedTouches[0].clientY;
    }, { passive: true });
    productMainImg.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        navigateGallery(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
  }

  /* ── SCROLL FADE-IN ANIMATIONS ── */
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.ingredient-card, .testimonial-card, .principle-card, .science-card, .faq-item').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  // Add visible class style
  const style = document.createElement('style');
  style.textContent = '.visible { opacity: 1 !important; transform: translateY(0) !important; }';
  document.head.appendChild(style);

  /* ── AJAX ADD TO CART ── */

  function updateCartBadge(count) {
    document.querySelectorAll('.cart-badge').forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('cart-badge--hidden', count === 0);
    });
    document.querySelectorAll('.cart-count-mobile').forEach(function (el) {
      el.textContent = count;
    });
  }

  function ajaxAddToCart(variantId, quantity, btn, sellingPlan) {
    if (!variantId || btn.disabled) return;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    const cartBody = { id: Number(variantId), quantity: quantity || 1 };
    if (sellingPlan) cartBody.selling_plan = sellingPlan;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(cartBody)
    })
    .then(function (res) {
      if (res.ok) {
        btn.textContent = 'Added! ✓';
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartBadge(cart.item_count); });
      } else {
        return res.json().then(function (data) {
          btn.textContent = data.description || 'Try again';
        }).catch(function () {
          btn.textContent = 'Try again';
        });
      }
    })
    .catch(function () {
      btn.textContent = 'Try again';
    })
    .finally(function () {
      setTimeout(function () {
        if (!btn.dataset.soldOut) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      }, 2000);
    });
  }

  // Flavours carousel and any standalone .js-ajax-atc buttons
  document.querySelectorAll('.js-ajax-atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      ajaxAddToCart(btn.dataset.variantId, 1, btn);
    });
  });

  // Product page form (supports variant select + qty stepper)
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    const productSubmitBtn = productForm.querySelector('[name="add"]');
    if (productSubmitBtn) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const idField     = productForm.querySelector('[name="id"]');
        const qtyField    = document.getElementById('qty-input');
        const planField   = document.getElementById('selling_plan');
        const variantId   = idField ? idField.value : null;
        const quantity    = qtyField ? parseInt(qtyField.value, 10) : 1;
        const sellingPlan = planField && planField.value ? planField.value : null;
        ajaxAddToCart(variantId, quantity, productSubmitBtn, sellingPlan);
      });

      const variantSelect = productForm.querySelector('.variant-select');
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          const selectedOption = this.options[this.selectedIndex];
          const available = selectedOption.dataset.available === 'true';
          productSubmitBtn.disabled = !available;
          productSubmitBtn.dataset.soldOut = available ? '' : '1';
          if (!available) {
            productSubmitBtn.textContent = 'SOLD OUT';
          } else {
            updateOfferUI();
          }
        });
      }
    }
  }

  // Selling plan selector — sync radio to hidden selling_plan input
  document.querySelectorAll('[name="selling_plan_radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      const planInput = document.getElementById('selling_plan');
      if (planInput) planInput.value = radio.value;
      updateOfferUI();
    });
  });

  /* ── BUY 2 GET 1 FREE — OFFER UI ── */
  var offerBlock     = document.getElementById('offer-block');
  var offerHint      = document.getElementById('offer-hint');
  var addCartBtn     = document.getElementById('add-to-cart-btn');
  var qtyQuickBtns   = document.querySelectorAll('.qty-quick-btn');

  function isSubscription() {
    var checked = document.querySelector('[name="selling_plan_radio"]:checked');
    return checked && checked.value !== '';
  }

  function syncQuickSelect(qty) {
    qtyQuickBtns.forEach(function (btn) {
      var match = parseInt(btn.dataset.qty, 10) === qty;
      btn.classList.toggle('qty-quick-btn--active', match);
      btn.setAttribute('aria-pressed', match ? 'true' : 'false');
    });
  }

  function updateOfferUI() {
    if (!qtyInput) return;
    var qty = parseInt(qtyInput.value, 10) || 1;
    var sub = isSubscription();

    syncQuickSelect(qty);

    if (offerBlock) {
      offerBlock.classList.toggle('offer-block--inactive', sub);
    }

    if (addCartBtn && !addCartBtn.dataset.soldOut) {
      if (offerBlock && !sub && qty >= 3) {
        addCartBtn.textContent = 'ADD 3 – GET 1 FREE';
      } else {
        addCartBtn.textContent = 'ADD TO CART';
      }
    }

    if (offerHint) {
      if (!sub && qty === 2) {
        offerHint.textContent = 'Add 1 more for a free box';
        offerHint.hidden = false;
      } else if (!sub && qty === 1) {
        offerHint.textContent = 'When you add any 3 to your cart, 1 is FREE';
        offerHint.hidden = false;
      } else {
        offerHint.hidden = true;
        offerHint.textContent = '';
      }
    }
  }

  qtyQuickBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (qtyInput) {
        qtyInput.value = parseInt(btn.dataset.qty, 10);
        qtyInput.dispatchEvent(new Event('change'));
      }
    });
  });

  if (qtyInput) {
    qtyInput.addEventListener('change', updateOfferUI);
    qtyInput.addEventListener('input', updateOfferUI);
  }

  updateOfferUI();

  // Collection page per-product forms
  document.querySelectorAll('.collection-atc-form').forEach(function (form) {
    const btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const idField = form.querySelector('[name="id"]');
      ajaxAddToCart(idField ? idField.value : null, 1, btn);
    });
  });

  /* ── PHOTO GALLERY CAROUSELS ── */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    const track   = gallery.querySelector('.gallery-track');
    const slides  = Array.from(gallery.querySelectorAll('.gallery-slide'));
    const dots    = Array.from(gallery.querySelectorAll('.gallery-dot'));
    const prevBtn = gallery.querySelector('.gallery-arrow-prev');
    const nextBtn = gallery.querySelector('.gallery-arrow-next');

    if (!slides.length || !track) return;

    let currentIndex = 0;

    function getVisibleCount() { return window.innerWidth <= 768 ? 1 : 3; }

    function getMaxIndex() { return Math.max(0, slides.length - getVisibleCount()); }

    function getSlideOffset() {
      const style = getComputedStyle(track);
      const gap   = parseFloat(style.columnGap || style.gap) || 16;
      return slides[0].offsetWidth + gap;
    }

    function goTo(index) {
      const max    = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, max));

      track.style.transform = 'translateX(-' + (currentIndex * getSlideOffset()) + 'px)';

      dots.forEach(function (dot, i) {
        const active = i === currentIndex;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-selected', String(active));
      });

      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= max;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(Math.min(currentIndex, getMaxIndex())); }, 150);
    });

    var viewport = gallery.querySelector('.gallery-viewport');
    if (viewport) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      viewport.addEventListener('touchstart', function (e) {
        swipeStartX = e.changedTouches[0].clientX;
        swipeStartY = e.changedTouches[0].clientY;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - swipeStartX;
        var dy = e.changedTouches[0].clientY - swipeStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          goTo(currentIndex + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    goTo(0);
  });


  /* ── COLLECTION SORT ── */
  var sortSelect = document.querySelector('.js-collection-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── PRODUCT PAGE ACCORDION ── */
  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item   = this.closest('.accordion-item');
      var isOpen = item.classList.contains('is-open');
      var icon   = this.querySelector('.accordion-icon');

      document.querySelectorAll('.accordion-item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        openItem.querySelector('.accordion-icon').textContent = '+';
        openItem.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        icon.textContent = '−';
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── CART PAGE ── */
  var cpCards = document.getElementById('cp-cards');
  if (cpCards) {
    function cpUpdateCart(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cpRender(cart);
        updateCartBadge(cart.item_count);
      });
    }

    function cpRender(cart) {
      var cardsEl    = document.getElementById('cp-cards');
      var headingEl  = document.getElementById('cp-heading');
      var layoutEl   = document.getElementById('cp-layout');
      var emptyEl    = document.getElementById('cp-empty');
      var subtotalEl = document.getElementById('cp-subtotal');

      if (headingEl) {
        headingEl.innerHTML = cart.item_count > 0
          ? 'Cart&nbsp;(' + cart.item_count + ')'
          : 'Cart';
      }

      if (cart.item_count === 0) {
        if (layoutEl) layoutEl.style.display = 'none';
        if (emptyEl)  emptyEl.style.display  = 'flex';
        return;
      }

      if (subtotalEl) subtotalEl.textContent = formatCartPrice(cart.total_price);

      if (cardsEl) {
        cardsEl.innerHTML = cart.items.map(function(item) {
          var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<p class="cp-card-variant">' + item.variant_title + '</p>'
            : '';
          var isFree = item.final_line_price === 0 && item.original_line_price > 0;
          var priceHtml = isFree
            ? '<span class="cart-free-badge">FREE</span>'
            : '<span class="cp-card-price">' + formatCartPrice(item.final_line_price) + '</span>';
          var trashSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
            + '<polyline points="3 6 5 6 21 6"/>'
            + '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>'
            + '<path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>'
            + '</svg>';
          return '<div class="cp-card" data-key="' + item.key + '">'
            + '<img class="cp-card-img" src="' + (item.image || '') + '" alt="' + item.product_title + '" loading="lazy">'
            + '<div class="cp-card-body">'
            + '<div class="cp-card-top">'
            + '<div class="cp-card-info"><p class="cp-card-title">' + item.product_title + '</p>' + variantHtml + '</div>'
            + priceHtml
            + '</div>'
            + '<div class="cp-card-qty">'
            + '<button class="cp-qty-delete" data-key="' + item.key + '" aria-label="Remove item">' + trashSvg + '</button>'
            + '<span class="cp-qty-num">' + item.quantity + '</span>'
            + '<button class="cp-qty-plus" data-key="' + item.key + '" aria-label="Increase quantity">+</button>'
            + '</div>'
            + '</div>'
            + '</div>';
        }).join('');

        updateOfferBanner('cp-offer-banner', cart);
        cpBindHandlers();
      }
    }

    function cpBindHandlers() {
      document.querySelectorAll('.cp-qty-delete').forEach(function(btn) {
        btn.addEventListener('click', function() {
          cpUpdateCart(btn.dataset.key, 0);
        });
      });
      document.querySelectorAll('.cp-qty-plus').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var card = btn.closest('.cp-card');
          var qty  = parseInt(card.querySelector('.cp-qty-num').textContent, 10) + 1;
          cpUpdateCart(btn.dataset.key, qty);
        });
      });
    }

    cpBindHandlers();
  }

  /* ── CART DRAWER ── */
  var cartDrawerEl       = document.getElementById('cart-drawer');
  var cartOverlayEl      = document.getElementById('cart-overlay');

  function openCartDrawer() {
    if (!cartDrawerEl) return;
    fetchCartAndRender();
    cartDrawerEl.classList.add('open');
    cartOverlayEl.classList.add('active');
    cartDrawerEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawerEl) return;
    cartDrawerEl.classList.remove('open');
    cartOverlayEl.classList.remove('active');
    cartDrawerEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function fetchCartAndRender() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); });
  }

  function formatCartPrice(cents) {
    return 'AED ' + (cents / 100).toFixed(2);
  }

  function getCartOfferBanner(cart) {
    var hasFree = cart.items.some(function (i) {
      return i.final_line_price === 0 && i.original_line_price > 0;
    });
    var total = cart.item_count;
    if (hasFree || total >= 3) return { html: '&#10003; Buy 2 Get 1 Free applied', applied: true };
    if (total === 2)           return { html: 'Add <strong>1 more box</strong> to get 1 free', applied: false };
    if (total === 1)           return { html: 'Add <strong>2 more boxes</strong> to get 1 free', applied: false };
    return null;
  }

  function updateOfferBanner(bannerId, cart) {
    var el = document.getElementById(bannerId);
    if (!el) return;
    var offer = getCartOfferBanner(cart);
    if (offer) {
      el.innerHTML = offer.html;
      el.classList.toggle('cart-offer-banner--applied', offer.applied);
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function renderCartDrawer(cart) {
    var itemsEl   = document.getElementById('cart-drawer-items');
    var emptyEl   = document.getElementById('cart-drawer-empty');
    var summaryEl = document.getElementById('cart-drawer-summary');
    if (!itemsEl) return;

    updateCartBadge(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      emptyEl.style.display = 'flex';
      summaryEl.style.display = 'none';
    } else {
      emptyEl.style.display = 'none';
      summaryEl.style.display = 'block';

      itemsEl.innerHTML = cart.items.map(function(item) {
        var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<span class="cart-drawer-item-variant">' + item.variant_title + '</span>'
          : '';
        var isFree = item.final_line_price === 0 && item.original_line_price > 0;
        var priceHtml = isFree
          ? '<span class="cart-free-badge">FREE</span>'
          : '<span class="cart-drawer-item-price">' + formatCartPrice(item.final_line_price) + '</span>';
        var imgSrc = item.image || '';
        return '<div class="cart-drawer-item" data-key="' + item.key + '">'
          + '<img class="cart-drawer-item-img" src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">'
          + '<div class="cart-drawer-item-info">'
          + '<span class="cart-drawer-item-title">' + item.product_title + '</span>'
          + variantHtml
          + '<div class="cart-drawer-qty-row">'
          + '<button class="cart-drawer-qty-btn cart-drawer-qty-minus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>'
          + '<span class="cart-drawer-qty-num">' + item.quantity + '</span>'
          + '<button class="cart-drawer-qty-btn cart-drawer-qty-plus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>'
          + '</div>'
          + priceHtml
          + '</div>'
          + '<button class="cart-drawer-item-remove" data-key="' + item.key + '" aria-label="Remove ' + item.product_title + '">'
          + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
          + '<polyline points="3 6 5 6 21 6"/>'
          + '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>'
          + '<path d="M10 11v6"/><path d="M14 11v6"/>'
          + '<path d="M9 6V4h6v2"/>'
          + '</svg>'
          + '</button>'
          + '</div>';
      }).join('');

      updateOfferBanner('cart-offer-banner', cart);

      itemsEl.querySelectorAll('.cart-drawer-item-remove').forEach(function(btn) {
        btn.addEventListener('click', function() { removeCartItem(btn.dataset.key); });
      });
      itemsEl.querySelectorAll('.cart-drawer-qty-minus').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var row    = btn.closest('.cart-drawer-item');
          var newQty = parseInt(btn.dataset.qty, 10) - 1;
          row.querySelectorAll('.cart-drawer-qty-btn').forEach(function(b) { b.disabled = true; });
          if (newQty <= 0) {
            removeCartItem(btn.dataset.key);
          } else {
            changeCartItemQty(btn.dataset.key, newQty);
          }
        });
      });
      itemsEl.querySelectorAll('.cart-drawer-qty-plus').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var row = btn.closest('.cart-drawer-item');
          row.querySelectorAll('.cart-drawer-qty-btn').forEach(function(b) { b.disabled = true; });
          changeCartItemQty(btn.dataset.key, parseInt(btn.dataset.qty, 10) + 1);
        });
      });

      var subtotalEl = document.getElementById('cart-drawer-subtotal');
      var totalEl    = document.getElementById('cart-drawer-total');
      if (subtotalEl) subtotalEl.textContent = formatCartPrice(cart.total_price);
      if (totalEl)    totalEl.textContent    = formatCartPrice(cart.total_price);
    }
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); });
  }

  function changeCartItemQty(key, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); });
  }

  var cartIconBtn = document.getElementById('cart-icon-btn');
  if (cartIconBtn) cartIconBtn.addEventListener('click', openCartDrawer);
  if (cartOverlayEl) cartOverlayEl.addEventListener('click', closeCartDrawer);
  var cartDrawerCloseBtn    = document.getElementById('cart-drawer-close');
  var cartDrawerBackBtn     = document.getElementById('cart-drawer-back');
  var cartDrawerContinueBtn = document.getElementById('cart-drawer-continue');
  if (cartDrawerCloseBtn)    cartDrawerCloseBtn.addEventListener('click', closeCartDrawer);
  if (cartDrawerBackBtn)     cartDrawerBackBtn.addEventListener('click', closeCartDrawer);
  if (cartDrawerContinueBtn) cartDrawerContinueBtn.addEventListener('click', closeCartDrawer);

  /* ── FIXED HEADER WITH ANNOUNCEMENT BAR OFFSET ── */
  const header = document.querySelector('.site-header');
  const annBar  = document.querySelector('.announcement-bar');

  if (header) {
    let annBarHeight = annBar ? annBar.offsetHeight : 0;

    function positionHeader() {
      const offset = Math.max(0, annBarHeight - window.scrollY);
      header.style.top = offset + 'px';
      header.style.boxShadow = offset === 0
        ? '0 2px 20px rgba(0,0,0,0.12)'
        : '0 1px 12px rgba(0,0,0,0.06)';
    }

    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        annBarHeight = annBar ? annBar.offsetHeight : 0;
        positionHeader();
      }, 100);
    }, { passive: true });

    window.addEventListener('scroll', positionHeader, { passive: true });
    positionHeader();
  }

});
